import { numberToPrettyString } from '@cian/utils';
import type { IBuildingCard } from 'shared/types/buildingCard';
import { NBSP } from 'shared/constants/text';
import { noBreak } from 'shared/utils/format';

export interface IRate {
  name: 'Арендная ставка' | 'Стоимость';
  value: string;
}

const formatRange = (from: number, to: number | null, units: string): string => {
  const price = (value: number) => noBreak(numberToPrettyString(value));

  // В монолите одиночная ставка без ₽ — исправлено по решению пользователя
  if (to === null || from === to) {
    return `${price(from)}${NBSP}₽${NBSP}${units}`;
  }

  return `от${NBSP}${price(from)} до${NBSP}${price(to)}${NBSP}₽${NBSP}${units}`;
};

/** Ставки аренды и продажи как `detail/index.html` монолита: выводятся, если есть «от» */
export function getRates(card: IBuildingCard): IRate[] {
  const { rentFrom, rentTo, saleFrom, saleTo } = card.rates;
  const rates: IRate[] = [];

  if (rentFrom) {
    rates.push({ name: 'Арендная ставка', value: formatRange(rentFrom, rentTo, `за${NBSP}м²${NBSP}в${NBSP}год`) });
  }
  if (saleFrom) {
    rates.push({ name: 'Стоимость', value: formatRange(saleFrom, saleTo, `за${NBSP}м²`) });
  }

  return rates;
}
